var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class LayoutSwitcher extends Component {
    constructor() {
        super('LayoutSwitcher', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#layout-switcher a').on('click', (event, button) => {
                event.preventDefault();
                this.setLayout(button.data('layout'));
                this.saveState();
            });
            this.restoreState();
            this.success();
        });
    }
    saveState() {
        const activeLayout = $('#layout-switcher a.active').data('layout');
        const postType = $('#layout-switcher').data('postType');
        localStorage.setItem('layout-' + postType, activeLayout);
    }
    restoreState() {
        const postType = $('#layout-switcher').data('postType');
        const layout = localStorage.getItem('layout-' + postType);
        if (layout)
            this.setLayout(layout);
    }
    setLayout(layout) {
        $('#layout-switcher a').removeClass('active');
        $('#layout-switcher a[data-layout="' + layout + '"]').addClass('active');
        $('.layout-switcher-target').data('layout', layout);
    }
}
